import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import style from './style.css';

export default class FileInput extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    accept: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    multiple: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    hideSelected: PropTypes.bool.isRequired,
    fileName: PropTypes.string
  };

  static defaultProps = {
    placeholder: 'No file chosen',
    disabled: false,
    multiple: false,
    children: 'Choose File',
    fileName: '',
    hideSelected: false
  };

  constructor() {
    super(...arguments);
  }

  handleChange(e) {
    if (this.props.onChange) this.props.onChange(e.currentTarget.files);
  }

  render() {
    let {name, accept, placeholder, disabled, fileName,
      multiple, children, hideSelected} = this.props;
    fileName = fileName || '';
    return (
      <span className={style.fileInput}>
        <input
         ref="file"
         type="file"
         tabIndex="-1"
         name={name} value=""
         onChange={this.handleChange.bind(this)}
         accept={accept}
         disabled={disabled}
         multiple={multiple} />
        <Button
         disabled={disabled}
         onClick={() => this.refs.file.click()}
         name={`${name}_button`}>
          {children}
        </Button>
        {hideSelected ? null :
        <input
         type="text"
         tabIndex="-1"
         name={`${name}_filename`}
         size={Math.min(Math.max(fileName.length, 20), 120)}
         value={fileName}
         onMouseDown={(e) => {
            this.refs.file.click();
            e.preventDefault();
          }}
         onChange={() => {}}
         placeholder={placeholder}
         disabled={disabled}
         readOnly={true} />}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/file-input.js